// İletişim ve adres. İl, Türkiye'deyken 81 il listesinden seçilir; listede olmayan yazı da kabul edilir.
import React from 'react';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TURKEY_PROVINCE_NAMES } from '../../../../../constants/turkeyProvinces';
import type { AccountCardForm } from '../useAccountCardForm';
import { GroupLabel, L, SectionTitle } from './fields';

const isTurkey = (country: string) => {
  const c = country.trim().toLocaleLowerCase('tr-TR');
  return c === '' || c === 'türkiye' || c === 'turkiye' || c === 'turkey' || c === 'tr';
};

export const ContactSection: React.FC<{ f: AccountCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  const d = f.accountData;
  const emailRequired = d.isEcommerceUser;
  return (
    <>
      <SectionTitle title={t(`${L}.layout.sections.contact`, 'İletişim ve adres')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth size="small" type="tel" label={t(`${L}.fields.mobilePhone`)} placeholder={t(`${L}.placeholders.phone`)}
            value={d.mobilePhone} onChange={(e) => f.handleChange('mobilePhone', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth size="small" type="tel" label={t(`${L}.fields.phone`)} placeholder={t(`${L}.placeholders.phone`)}
            value={d.phone} onChange={(e) => f.handleChange('phone', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="account-card-email"
            fullWidth size="small" type="email" label={t(`${L}.fields.email`)}
            required={emailRequired}
            error={emailRequired && !d.email.trim() && !!f.error}
            helperText={emailRequired ? t(`${L}.layout.emailForEcom`, 'E-ticaret girişi için gerekli') : undefined}
            value={d.email} onChange={(e) => f.handleChange('email', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth size="small" label={t(`${L}.fields.website`)} placeholder={t(`${L}.placeholders.website`)}
            value={d.website} onChange={(e) => f.handleChange('website', e.target.value)}
          />
        </Grid>
      </Grid>

      <GroupLabel>{t(`${L}.sections.addressInfo`)}</GroupLabel>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth size="small" label={t(`${L}.fields.country`)}
            value={d.country} onChange={(e) => f.handleChange('country', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          {isTurkey(d.country) ? (
            <Autocomplete
              freeSolo
              size="small"
              options={TURKEY_PROVINCE_NAMES}
              value={d.city}
              onChange={(_, v) => f.handleChange('city', v || '')}
              onInputChange={(_, v, reason) => { if (reason === 'input') f.handleChange('city', v); }}
              renderInput={(params) => <TextField {...params} label={t(`${L}.fields.city`)} />}
            />
          ) : (
            <TextField
              fullWidth size="small" label={t(`${L}.fields.city`)}
              value={d.city} onChange={(e) => f.handleChange('city', e.target.value)}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth size="small" label={t(`${L}.fields.district`)}
            value={d.district} onChange={(e) => f.handleChange('district', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            fullWidth size="small" multiline minRows={2} label={t(`${L}.fields.address`)}
            value={d.address} onChange={(e) => f.handleChange('address', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth size="small" label={t(`${L}.fields.postalCode`)}
            value={d.postalCode} onChange={(e) => f.handleChange('postalCode', e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
};
